"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const secp256k1_1 = require("secp256k1");
const abi_1 = require("../abi");
const buffer_1 = require("../buffer");
const crypto_1 = require("../crypto");
const ecdsa_1 = require("../ecdsa");
const constatnts_1 = require("./constatnts");
function toChecksumAddress(address) {
    address = address.toLowerCase();
    if (address.startsWith('0x')) {
        address = address.slice(2);
    }
    const hash = crypto_1.sha3(address).toString('hex');
    const chars = address
        .split('')
        .map((char, index) => parseInt(hash[index], 16) >= 8
        ? char.toUpperCase()
        : char);
    return `0x${chars.join('')}`;
}
exports.toChecksumAddress = toChecksumAddress;
function bufferToAddress(buff) {
    return toChecksumAddress(buff.toString('hex'));
}
exports.bufferToAddress = bufferToAddress;
function computeCreate2Address(deployer, salt, byteCodeHash) {
    let codeHash = buffer_1.anyToBuffer(byteCodeHash);
    if (codeHash.length !== 32) {
        codeHash = crypto_1.sha3(codeHash);
    }
    const payload = abi_1.abiEncodePacked('bytes', 'address', 'bytes32', 'bytes')('0xff', deployer, salt, codeHash);
    return bufferToAddress(crypto_1.sha3(payload).slice(-20));
}
exports.computeCreate2Address = computeCreate2Address;
function verifyAddress(address, checksum = true) {
    let result = false;
    if (address &&
        /^(0x)?[0-9a-fA-F]{40}$/i.test(address) &&
        address !== constatnts_1.ZERO_ADDRESS) {
        if (checksum) {
            result = address === toChecksumAddress(address);
        }
        else {
            result = true;
        }
    }
    return result;
}
exports.verifyAddress = verifyAddress;
function targetToAddress(target) {
    let result = null;
    switch (typeof target) {
        case 'string':
            result = target || null;
            break;
        case 'object':
            if (target && typeof target.address === 'string') {
                result = target.address || null;
            }
            break;
    }
    return result;
}
exports.targetToAddress = targetToAddress;
function convertAddress(address) {
    let result = null;
    const buff = buffer_1.anyToBuffer(address);
    if (buff && buff.length === 20) {
        result = bufferToAddress(buff);
    }
    return result;
}
exports.convertAddress = convertAddress;
function publicKeyToAddress(publicKey) {
    let result = null;
    try {
        publicKey = secp256k1_1.publicKeyConvert(publicKey, false);
        if (ecdsa_1.verifyPublicKey(publicKey)) {
            result = bufferToAddress(crypto_1.sha3(publicKey.slice(1)).slice(-20));
        }
    }
    catch (err) {
        result = null;
    }
    return result;
}
exports.publicKeyToAddress = publicKeyToAddress;
function privateKeyToAddress(privateKey) {
    let result = null;
    try {
        const publicKey = ecdsa_1.privateToPublicKey(privateKey);
        if (publicKey) {
            result = publicKeyToAddress(publicKey);
        }
    }
    catch (err) {
        result = null;
    }
    return result;
}
exports.privateKeyToAddress = privateKeyToAddress;
//# sourceMappingURL=utils.js.map